import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "inputs", "count", "btnCount"]

  send() {
    const checked = document.querySelectorAll(".recipient-checkbox:checked")

    if (checked.length === 0) {
      alert("Please select at least one recipient.")
      return
    }

    if (!confirm("Are you sure you want to send this newsletter? This cannot be undone.")) return

    this.inputsTarget.innerHTML = ""
    checked.forEach(cb => {
      const emailInput = document.createElement("input")
      emailInput.type = "hidden"
      emailInput.name = "recipients[][email]"
      emailInput.value = cb.dataset.email

      const nameInput = document.createElement("input")
      nameInput.type = "hidden"
      nameInput.name = "recipients[][name]"
      nameInput.value = cb.dataset.name

      this.inputsTarget.appendChild(emailInput)
      this.inputsTarget.appendChild(nameInput)
    })

    this.formTarget.requestSubmit()
  }

  updateCounts() {
    const count = document.querySelectorAll(".recipient-checkbox:checked").length
    if (this.hasCountTarget) this.countTarget.textContent = `${count} recipient(s)`
    if (this.hasBtnCountTarget) this.btnCountTarget.textContent = count
  }
}
